import { CLEAR_ELIGIBLE_DELEGATE_STRUCTS } from "../../../../enums/MyDivision/Delegation/RequestsDelegation.types";

export const clearEligibleDelegateStructsAction = () => {
    return {
        type: CLEAR_ELIGIBLE_DELEGATE_STRUCTS,
    };
};